import {
  useWebModalStore,
  type CreatorDeliveryCompletion
} from './useWebModalStore';

// Producers publish a completed stage; only the detail page renders its dialog.
export function showCreatorDeliveryCompletion(
  completion: CreatorDeliveryCompletion
) {
  if (!completion.isCurrentVisit()) return;
  useWebModalStore.setState({
    deliveryCompletion: completion,
    nowSuccessNode: completion.node,
    showModalBonusNext: completion.mode === 'bonus',
    showModalNodeSuccess: completion.mode === 'node'
  });
}

export function clearCreatorDeliveryCompletion(
  completion: CreatorDeliveryCompletion
) {
  if (useWebModalStore.getState().deliveryCompletion !== completion) return;
  useWebModalStore.setState({
    deliveryCompletion: null,
    showModalBonusNext: false,
    showModalNodeSuccess: false
  });
}
